import { UseFormRegisterReturn } from 'react-hook-form'

import { useClass } from '@/hooks/useClass'

type TextAreaProps = React.ComponentProps<'textarea'> & {
  error?: string
  register: UseFormRegisterReturn
}

export const TextArea = ({
  error,
  className,
  register,
  ...props
}: TextAreaProps) => {
  const textareaClass = useClass(
    'bg-transparent P-16 rounded-[8px] border border-ui-2 w-full text-primary placeholder:text-placeholder',
    className
  )

  return (
    <div>
      <textarea className={textareaClass} {...props} {...register} />
      {Boolean(error) && <p className="pt-4 font-normal text-error">{error}</p>}
    </div>
  )
}
